import { apiUrl } from "../Utility";
import _ from "lodash";
export const TEMP_PLAYLIST = "TEMP_PLAYLIST";
export const ITEM_MOVED = "ITEM_MOVED";
export const ITEM_MOVE_BEGIN = "ITEM_MOVE_BEGIN";
export const RESET_IS_FIRST_MOVE = "RESET_IS_FIRST_MOVE";
export const REMOVE_VIDEO_FROM_PLAYLIST = 'REMOVE_VIDEO_FROM_PLAYLIST'
export const SET_ID = 'SET_ID'

export const DragEnd = result => {
  return (dispatch, getState) => {
    dispatch({ type: ITEM_MOVED, result });
  };
};

export const SetPlaylistID = id => {
  return (dispatch, getState) => {
    dispatch({type: SET_ID, id})
  }
}

export const DragStart = () => {
  return (dispatch, getState) => {
    dispatch({ type: ITEM_MOVE_BEGIN });
  };
};

export const copyPlaylist = () => {
  return (dispatch, getState) => {
    let currentState = getState();
    // console.log(currentState.mainState.playList);
    let playlist = currentState.mainState.playList;
    dispatch({ type: TEMP_PLAYLIST, playlist });
  };
};

export const resetFirstMove = () => {
  return (dispatch, getState) => {
    dispatch({ type: RESET_IS_FIRST_MOVE });
  };
};

export const deleteVideo = (id) => {
  return (dispatch, getState) => {
    dispatch({type: REMOVE_VIDEO_FROM_PLAYLIST, id})
  }
}

export const saveChanges = (id, token) => {
  return (dispatch, getState) => {
    dispatch({type: 'RESET_IS_FIRST_MOVE'})
    const currentState = getState();
    let updatedPlaylist = JSON.parse(
      JSON.stringify(
        currentState.tempState.playList.contents.video_user_categories
      )
    );
    for (let i = 0; i < updatedPlaylist.length; i++) {
      updatedPlaylist[i].order_in_category = i;
    }
    // console.log(updatedPlaylist)
    // console.log(id)
    // console.log(token)
    fetch(
      `https://${apiUrl}/api/v1/user/categories/${id}/videos/updateAll?token=${token}`,
      {
        method: "POST",
        body: JSON.stringify({video_user_categories: updatedPlaylist}),
        headers: new Headers({
          "Content-Type": "application/json"
        })
      }
    )
      .then(res => {
        res.json().then(res => {
          // console.log(res)
          if (res.status === "success") {
            console.log(res);
          }
        });
      })
      .catch(e => {
        // console.log(e);
      });
  };
};

export const resetPlaylist = () => {
  return (dispatch, getState) => {
    let state = JSON.parse(JSON.stringify(getState()))
    let res = state.mainState.playList.contents
    dispatch({ type: TEMP_PLAYLIST, res });
    dispatch({ type: RESET_IS_FIRST_MOVE }) 
  }
}



// WEBPACK FOOTER //
// ./src/js/Actions/TempPlaylistActions.js